"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Download.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Download = function Download(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 24.81 20.2"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Download icon"), _react2.default.createElement("g", {
    className: "download",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M22.81,15.49A2.71,2.71,0,0,1,20.1,18.2H4.71A2.71,2.71,0,0,1,2,15.49V9.36H0v6.13A4.72,4.72,0,0,0,4.71,20.2H20.1a4.72,4.72,0,0,0,4.71-4.71V9.36h-2v6.13Z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("polygon", {
    points: "16.71 9.39 13.4 12.69 13.4 0 11.4 0 11.4 12.73 8.1 9.43 6.69 10.84 12.37 16.53 12.43 16.48 12.43 16.49 18.12 10.8 16.71 9.39",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  })));
};
exports.default = Download;